import {Component, OnInit} from '@angular/core';
import {NavigationItem} from 'features/core/shared/dto/navigation/navigation-item';
import {ObjectBaseModeComponent} from 'features/core/shared/object/mvs-object-base/object-base-mode.component';

/**
 * Base-mode component of the Provisionszeile OBC (layer 2 of the three-layer pattern).
 *
 * Same shape as the two sibling base components of this module: no template of its own
 * (`template: ''`), only the `navigationItems`; `full` and `side` inherit and render one shared
 * component per item. `ObjectBaseModeComponent` subscribes to `?navItem=` / `?sideNavItem=`
 * itself, so nothing has to be rebuilt here.
 *
 * The four items separate what a caseworker asks in sequence: WHICH time slice is this
 * (Basisdaten), WHAT did the run compute for it (Berechnung), WHO gets paid from it
 * (Provisionssätze), and IS it cancelled (Storno). Splitting Berechnung off is not cosmetic — it
 * is the block that stands empty on a manually created row, and it is where the FD-7(a) hint is
 * rendered per field.
 */
@Component({
    selector: 'cp-provision-contract-base',
    template: '',
    standalone: false
})
export class CpProvisionContractBaseComponent extends ObjectBaseModeComponent implements OnInit {

    /** `action` (not `route`) is the key — it is matched against `?navItem=`. */
    navigationItems: NavigationItem[] = [
        {
            label: 'Basisdaten',
            action: 'baseData',
            tooltip: 'Vertrag, Provisionstyp, Ereignis und die Zeitscheibe dieser Provisionszeile',
            icon: 'fa-regular fa-id-card',
            toggleable: false,
            default: true
        },
        {
            label: 'Berechnung',
            action: 'calculation',
            tooltip: 'Relevanz, Provisionsbasis und Basisbeträge des Ereignisses',
            icon: 'fa-regular fa-calculator',
            toggleable: false,
            default: false
        },
        {
            label: 'Provisionssätze',
            action: 'contractAgents',
            tooltip: 'Provisionssätze, die aus dieser Provisionszeile entstanden sind',
            icon: 'fa-regular fa-users',
            toggleable: false,
            default: false
        },
        {
            label: 'Storno',
            action: 'cancellation',
            tooltip: 'Stornodatum und Stornogrund',
            icon: 'fa-regular fa-ban',
            toggleable: false,
            default: false
        }
    ];

    ngOnInit() {
        super.ngOnInit();
        this.initialized = true;
    }

}
